import { render, staticRenderFns } from "./SupportMaterial.vue?vue&type=template&id=0555a1bf&"
import script from "./SupportMaterial.vue?vue&type=script&lang=js&"
export * from "./SupportMaterial.vue?vue&type=script&lang=js&"
import style0 from "./SupportMaterial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SupportMaterial.vue"
export default component.exports